import { useEffect, useState } from "react";
import { Link, useSearchParams } from "react-router-dom";
import axios from "axios";
import { Check, Loader2 } from "lucide-react";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const ShopSuccess = () => {
  const [params] = useSearchParams();
  const sessionId = params.get("session_id");
  const [status, setStatus] = useState("checking");

  useEffect(() => {
    document.title = "Order Confirmed — ADD VALUE Clothing";
    if (!sessionId) {
      setStatus("unknown");
      return;
    }
    let attempts = 0;
    const poll = async () => {
      try {
        const res = await axios.get(`${API}/payments/status/${sessionId}`);
        if (res.data.payment_status === "paid") {
          setStatus("paid");
          return;
        }
      } catch {
        // keep polling
      }
      attempts += 1;
      if (attempts < 12) setTimeout(poll, 2000);
      else setStatus("pending");
    };
    poll();
  }, [sessionId]);

  return (
    <div data-testid="shop-success-page" className="flex min-h-screen items-center">
      <div className="mx-auto w-full max-w-2xl px-6 py-40 text-center sm:px-8">
        {status === "paid" ? (
          <>
            <span className="mx-auto flex h-16 w-16 items-center justify-center border border-stone-300">
              <Check className="h-7 w-7 text-stone-200" />
            </span>
            <h1
              data-testid="order-confirmed-heading"
              className="mt-10 font-serif text-3xl tracking-tight text-white sm:text-4xl"
            >
              Order confirmed.
            </h1>
            <p className="mx-auto mt-6 max-w-md text-sm font-light leading-relaxed text-stone-400">
              Thank you. Your payment was received and your piece from
              Collection 001 is being prepared. A receipt has been sent to your
              email by Stripe.
            </p>
          </>
        ) : (
          <>
            <Loader2 className="mx-auto h-8 w-8 animate-spin text-stone-300" />
            <h1 className="mt-10 font-serif text-3xl tracking-tight text-white sm:text-4xl">
              {status === "pending" ? "Almost there." : "Confirming your order…"}
            </h1>
            <p className="mx-auto mt-6 max-w-md text-sm font-light leading-relaxed text-stone-400">
              {status === "pending"
                ? "Your payment is still being confirmed. If you completed checkout, your order will be processed — check your email for the Stripe receipt."
                : "Hold on a moment while we confirm your payment."}
            </p>
          </>
        )}
        <div className="mt-12 flex justify-center gap-4">
          <Link
            data-testid="success-back-to-shop"
            to="/shop"
            className="inline-flex items-center gap-3 bg-white px-8 py-4 font-mono text-[11px] uppercase tracking-[0.25em] text-black transition-colors duration-300 hover:bg-stone-300"
          >
            Back to the Shop
          </Link>
          <Link
            data-testid="success-back-home"
            to="/"
            className="inline-flex items-center gap-3 border border-white/30 px-8 py-4 font-mono text-[11px] uppercase tracking-[0.25em] text-white transition-colors duration-300 hover:border-stone-300"
          >
            Home
          </Link>
        </div>
        <p className="mt-16 font-mono text-[10px] uppercase tracking-[0.35em] text-stone-600">
          Creating · Building · Adding Value
        </p>
      </div>
    </div>
  );
};

export default ShopSuccess;
